import { defineStore } from "pinia";
import { useCurationExperienceStore } from "@/features/experience-curation/stores/useCurationExperienceStore";
import { useCurrentBookingInformationQuery } from "@/features/experience-curation/queries/useBookingInformationQuery";
import { useMasterData } from "@/stores/master-data";
import { areNonCommercialFieldsEditableForUser } from "@/features/experience-curation/lib/viewTypeUtils";
import { useHasFunctionalNestedFieldChange } from "@/features/experience-curation/queries/useHasRawFieldChange";
import { useComplexModelModelWithChanges } from "@/features/core-shared/composables/useComplexModelWithChanges";
import type { ContactNumber } from "@/types/generated/MetadataExperiencesApi";

export const useCurationEmergencyContact = defineStore("curation-customer-info-emergency-contact-field", () => {
  const curationExperienceStore = useCurationExperienceStore();
  const bookingInfoQuery = useCurrentBookingInformationQuery();
  const masterData = useMasterData();

  const initialValue = computed(() => ({
    country_calling_code:
      bookingInfoQuery.data.value?.bookingInformation?.emergency_contact_number?.country_calling_code ?? "",
    number: bookingInfoQuery.data.value?.bookingInformation?.emergency_contact_number?.number ?? "",
  }));
  const { model, hasChanges, isFilled, reset } = useComplexModelModelWithChanges<ContactNumber>(initialValue);

  const isRequired = false;
  const isReadonly = computed(() => curationExperienceStore.isReadonly || !areNonCommercialFieldsEditableForUser());
  const isVisible = computed(() => !curationExperienceStore.isCommercialView);
  const countries = computed(() => masterData.geoCountries);
  const hasUnpublishedChange = useHasFunctionalNestedFieldChange(
    (f) => f?.booking_information?.emergency_contact_number
  );

  return {
    id: "emergency_contact",
    model,
    countries,
    isRequired,
    isReadonly,
    isVisible,
    hasChanges,
    hasUnpublishedChange,
    isFilled,
    reset,
  };
});
